(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-data-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ProductDataSlideshow extends HTMLElement {
    connectedCallback() {
      this.imgs = Array.from(this.querySelectorAll('.product-data-slideshow__img'));
      this.titles = Array.from(this.querySelectorAll('.product-data-slideshow__title'));
      this.active = -1;
      this.setActive(0);
      this.titles.forEach((btn) => {
        const idx = Number(btn.dataset.index);
        btn.addEventListener('mouseenter', () => this.setActive(idx));
        btn.addEventListener('focus', () => this.setActive(idx));
        btn.addEventListener('click', () => this.setActive(idx));
      });
    }
    setActive(i) {
      if (i === this.active) return;
      this.active = i;
      this.imgs.forEach((img, idx) => img.classList.toggle('is-active', idx === i));
      this.titles.forEach((btn, idx) => btn.classList.toggle('is-active', idx === i));
    }
  }
  if (!customElements.get('product-data-slideshow')) {
    customElements.define('product-data-slideshow', ProductDataSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
